import { Typography, Box, styled, Button, useTheme } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BouncyMapPin from "../../animations/BouncyMapPin";
import { useAuth } from "../../hooks/AuthContext";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export default function RegionBar({ toggleRegionModal }) {
  const theme = useTheme();
  const { user } = useAuth();
  return (
    <Box
      display="flex"
      alignItems="center"
      gap={0.5}
      mt={0}
      elevation={4}
      sx={{
        cursor: "pointer",
        backgroundColor: "#FFF4E5",
        boxShadow: "10px 12px 32px 0 rgba(0, 0, 0, 0.04)",
        borderTop: "1px solid orangered",
        p: 1,
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        px: 2,
        height: "36px",
        zIndex: 999,
        position: "absolute",
      }}
    >
      <Box display="flex" alignItems="center" gap={1} sx={{ pl: 1.5 }}>
        <LocationOnIcon sx={{ color: "var(--primary-red-base)", fontSize: 20 }} />
        <LocationButton>
          {user?.region_name != null ? user?.region_name : "Select Location"}
        </LocationButton>
      </Box>

      <Button
        variant="text"
        onClick={toggleRegionModal}
        endIcon={<KeyboardArrowRightIcon />}
      >
        Change
      </Button>
    </Box>
  );
}

const LocationButton = styled(Button)(({ theme }) => ({
  fontWeight: 600,
  textTransform: "none",
  fontSize: "16px",
  padding: "6px 12px",
  display: "flex",
  alignItems: "center",
  display: "flex",
  color: "var(--neutral-800)",
  gap: 8,
  "&:hover": {
    backgroundColor: "transparent",
  },
  "& .MuiSvgIcon-root": {
    color: theme.palette.primary.main,
    fontSize: "24px !important",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px !important",
    },
  },

  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
    padding: "4px 8px",
    gap: 4,
  },
}));
